"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.record.id': 'ID de Registro',
    'onboarding.record.progress': 'Progreso',
    'onboarding.record.created': 'Creado',
    'onboarding.record.updated': 'Última Actualización',
    'onboarding.record.view': 'Ver Detalles',
    'onboarding.record.continue': 'Continuar',
};
